import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@/pages/ContactPage";

export const Route = createFileRoute("/contact")({
  head: () => routeHead('Contact AGAPE — Book a Discovery Call', META_DESCRIPTIONS.contact.en, '/contact'),
  component: ContactPage,
});
